<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="d-flex">
    <label
      for="projectAlias"
      class="gf-counted-input input-group input-group-sm mb-0"
      :data-current-length="result?.length + ' / ' + maxLength"
    >
      <div
        v-if="prependedText"
        class="input-group-prepend overflow-auto"
      >
        <span
          id="basic-addon3"
          class="input-group-text"
        >
          {{ prependedText }}
        </span>
      </div>
      <input
        id="projectAlias"
        v-model="result"
        class="form-control"
        :class="{ 'border-danger': formErrors.result || hasError }"
        type="text"
        name="projectAlias"
        inputmode="text"
        minlength="1"
        :maxlength="maxLength"
        required="required"
        :placeholder="placeholder"
        :disabled="!canBeModified"
        @input="onInput"
      />
    </label>
    <button
      v-if="canBeModified"
      type="button"
      class="d-flex align-items-center btn btn-primary btn-sm ml-2"
      :disabled="result === translitedText"
      :title="$t('translitor_title')"
      @click="returnTranslitedText"
    >
      <i class="gf-icon gf-icon-rotate-left" />
    </button>
  </div>
</template>

<script>
import sharedComponentsMessages from '@/shared-modules/shared-components/sharedComponentsMessages';
export default {
  name: 'GfCustomTranslitor',
  props: {
    prependedText: {
      type: String,
      default: null
    },
    textToTranslit: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    canBeModified: {
      type: Boolean,
      default: true
    },
    notNull: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'my-new-mega-project'
    },
    hasError: {
      type: String
    },
    maxLength: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      translitedText: '',
      result: '',
      formErrors: {
        result: false
      },
      isCustomTranslitedText: false
    };
  },
  watch: {
    textToTranslit(newValue) {
      this.translitedText = this.translitRusToLat(newValue);
      if (!this.isCustomTranslitedText) {
        this.result = this.translitedText;
        this.emitData();
      }
    },
    result() {
      this.checkResult();
    }
  },
  methods: {
    onInput() {
      this.isCustomTranslitedText = true;
      this.filterCyrillicChars();
      this.emitData();
    },
    returnTranslitedText() {
      this.isCustomTranslitedText = false;
      this.result = this.translitedText;
      this.emitData();
    },
    emitData() {
      this.$emit('input', this.result);
    },
    checkResult() {
      if (this.notNull && (this.result?.length === 0 || this.result?.length > this.maxLength)) {
        this.formErrors.result = true;
      } else {
        this.formErrors.result = false;
      }
      return this.formErrors.result;
    },
    translitRusToLat(string) {
      const ru = {
        а: 'a',
        б: 'b',
        в: 'v',
        г: 'g',
        д: 'd',
        е: 'e',
        ё: 'e',
        ж: 'j',
        з: 'z',
        и: 'i',
        к: 'k',
        л: 'l',
        м: 'm',
        н: 'n',
        о: 'o',
        п: 'p',
        р: 'r',
        с: 's',
        т: 't',
        у: 'u',
        ф: 'f',
        х: 'h',
        ц: 'c',
        ч: 'ch',
        ш: 'sh',
        щ: 'shch',
        ы: 'y',
        э: 'e',
        ю: 'u',
        я: 'ya'
      };
      const nStr = [];

      const newString = string
        .toLowerCase()
        .replace(/[ъь]+/g, '')
        .replace(/й/g, 'i')
        .replace(/ /g, '-');

      for (let i = 0; i < newString.length; ++i) {
        nStr.push(
          ru[newString[i]] ||
            (ru[newString[i].toLowerCase()] === undefined && newString[i]) ||
            ru[newString[i].toLowerCase()].toUpperCase()
        );
      }

      return nStr.join('');
    },
    filterCyrillicChars() {
      const valueToReplace = /[а-яА-Я]/g;
      this.result = this.result.replace(valueToReplace, '');
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss"></style>
